import { createContext, useContext } from 'react';

export type SignOutCallback = () => Promise<void> | void;

export type InactivitySignOutContextValue = {
    registerCallback: (id: string, callback: SignOutCallback) => void;
    unregisterCallback: (id: string) => void;
};

export const InactivitySignOutContext = createContext<InactivitySignOutContextValue | null>(null);

export function useInactivitySignOut() {
    const context = useContext(InactivitySignOutContext);

    if (!context) {
        throw new Error('useInactivitySignOut must be used within InactivitySignOutProvider');
    }

    return context;
}
